import { Col, Row } from "antd";
import React from "react";
import { AiOutlineUser } from "react-icons/ai";
import { FaRegClock } from "react-icons/fa";

function PageHeader({pageHeading}) {
  return (
    <Row gutter={[0, 16]}>
      <Col span={24}>
        <p className="page-heading">{pageHeading}</p>
      </Col>
      <Col span={24}>
        <Row gutter={[24, 0]}>
          <Col className="icon-btn">
            <AiOutlineUser />
            <span>Assign</span>
          </Col>
          <Col className="icon-btn">
            <FaRegClock />
            <span>Due Date</span>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default PageHeader;
